import { useSyncExternalStore } from "react";

/** True on touch-primary devices where hover tooltips never open (React Aria default). */
const QUERY = "(hover: none), (pointer: coarse)";
function subscribe(onStoreChange: () => void) {
  const mediaQuery = window.matchMedia(QUERY);
  mediaQuery.addEventListener("change", onStoreChange);
  return () => mediaQuery.removeEventListener("change", onStoreChange);
}
function getSnapshot() {
  return window.matchMedia(QUERY).matches;
}
function getServerSnapshot() {
  return false;
}
export function usePrefersTapTooltips() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}